import { memo } from "react";
import PropTypes from "prop-types";
import { resolutionPropType } from "app/utils/propTypes";
import { RESOLUTION } from "app/pages/.shared/responsive/responsiveReducer";
import ProgressiveImg from "app/pages/.shared/ProgressiveImg";

const IMG_SIZES = {
	small: { width: 1265 },
	medium: { width: 1265 },
	large: { width: 2880, height: 1100 },
	xlarge: { width: 2880, height: 1100 },
};

const CLOUDINARY_OPTIONS = ["c_fill"];

const SignupPageBackground = ({
	resolution,
	sourceBackgroundSmallUrl,
	sourceBackgroundSmallThumbnail,
	sourceBackgroundLargeUrl,
	sourceBackgroundLargeThumbnail,
	sourceForegroundSmallUrl,
	sourceForegroundLargeUrl,
	backgroundPosition,
}) => {
	const isSmallResolution = resolution === RESOLUTION.SMALL;

	const sourceBackground = isSmallResolution
		? sourceBackgroundSmallUrl
		: sourceBackgroundLargeUrl;

	const sourceForeground = isSmallResolution
		? sourceForegroundSmallUrl
		: sourceForegroundLargeUrl;

	const thumbnailBackground = isSmallResolution
		? sourceBackgroundSmallThumbnail
		: sourceBackgroundLargeThumbnail;

	return (
		<>
			<ProgressiveImg
				sizes={IMG_SIZES}
				cloudinaryOptions={CLOUDINARY_OPTIONS}
				src={sourceBackground}
				thumbnail={thumbnailBackground}
				backgroundPosition={backgroundPosition}
				cover
				disableLazyLoad
				fetchPriority="high"
			/>

			{sourceForeground && (
				<div
					className="signup-page-background__foreground"
					data-testid="signup-page-background-foreground"
				>
					<ProgressiveImg
						sizes={IMG_SIZES}
						cloudinaryOptions={CLOUDINARY_OPTIONS}
						src={sourceForeground}
						thumbnail={""}
						backgroundPosition={"left"}
						quality="q_auto:best"
						cover
						disableLazyLoad
						fetchPriority="high"
					/>
				</div>
			)}
		</>
	);
};

SignupPageBackground.propTypes = {
	resolution: resolutionPropType,
	sourceForegroundLargeUrl: PropTypes.string,
	sourceBackgroundSmallThumbnail: PropTypes.string,
	sourceBackgroundLargeUrl: PropTypes.string,
	sourceBackgroundLargeThumbnail: PropTypes.string,
	sourceForegroundSmallUrl: PropTypes.string,
	sourceBackgroundSmallUrl: PropTypes.string,
	backgroundPosition: PropTypes.string,
};

export default memo(SignupPageBackground);
